export const getProductInitialData = (product) => {
    return {
        product_id: product?.id,
        quantity: 0,
        totalPrice: 0,
        name: product?.name,
        price: product?.price,
        errors: [],
        max: product?.max,
        max_by_tickets_number: product?.max_by_tickets_number,
    }
}